/** @jsx jsx */

import React, { Fragment as _, useState, useEffect, useRef } from 'react';
import { css, jsx } from '@emotion/core';
import getTopics from 'services/apiHelpers/getTopics';
import { useSelector } from 'react-redux';
import pubSub from 'services/pubSub';
import getStore from 'services/getStore';
import { backBtnOnClick } from 'components/Header/BackBtn';

const store = getStore();

const HiddenBackButton = ({ id }) => {
  const [disabled, setDisabled] = useState(false);
  const currentTopic = useSelector(({ currentTopic }: any) => currentTopic);

  const isMounted = useRef(true);

  const getInteractions = () => {
    return Array.from(document.querySelectorAll('[data-section]'));
  };

  const getPrevSection = () => {
    const interactions = getInteractions();

    const currentSectionIndex = interactions.findIndex(
      (i: any) => i.id === `i${id}`
    );

    const prevSection = interactions[currentSectionIndex - 1];

    return prevSection;
  };

  const isModulesFirstInteraction = () => {
    const isTopic0 =
      getTopics().findIndex((t: any) => t.id === currentTopic) === 0;
    const hasPrevSection = !!getPrevSection();

    if (isTopic0) {
      if (!hasPrevSection) {
        return true;
      }
    }

    return false;
  };

  useEffect(() => {
    if (isModulesFirstInteraction()) {
      setDisabled(true);
    }

    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <button
      id={`hidden-back-button-${id}`}
      css={css`
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        border: 0;
        outline: 0;
        overflow: hidden;
      `}
      disabled={disabled}
      onClick={backBtnOnClick}
      onFocus={() => {
        pubSub.publish('HILITE_CHAMELEON_BACK_BUTTON', { toggle: true });
      }}
      onBlur={() => {
        pubSub.publish('HILITE_CHAMELEON_BACK_BUTTON', { toggle: false });
      }}
      aria-label="Go back"
    >
      {/* {id} */}
      Go back
    </button>
  );
};

export default HiddenBackButton;
